import { supabase } from './supabaseClient';
import { CronogramaItem, CronogramaInput } from './types';

export const getCronograma = async (obraId: number): Promise<CronogramaItem[]> => {
    const { data, error } = await supabase.rpc('get_cronograma', {
        p_obra_id: obraId
    });

    if (error) throw error;
    return data;
};

export const upsertCronograma = async (input: CronogramaInput) => {
    const { data, error } = await supabase.rpc('upsert_cronograma', {
        p_obra_id: input.obra_id,
        p_fase_id: input.fase_id,
        p_data_inicio: input.data_inicio || null,
        p_data_fim: input.data_fim || null,
        p_valor_previsto: input.valor_previsto,
        p_percentual_conclusao: input.percentual_conclusao,
        p_status: input.status,
        p_observacoes: input.observacoes
    });

    if (error) throw error;
    return data;
};
